"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "getNewSubZoneName", {
  enumerable: true,
  get: function get() {
    return _utils.getNewSubZoneName;
  }
});
Object.defineProperty(exports, "getOldSubZoneName", {
  enumerable: true,
  get: function get() {
    return _utils.getOldSubZoneName;
  }
});
Object.defineProperty(exports, "subZoneNameMapping", {
  enumerable: true,
  get: function get() {
    return _utils.subZoneNameMapping;
  }
});
var _zones = require("./zoning/zones");
var _utils = require("./zoning/utils");
var _default = exports["default"] = _zones.zones;